document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.shopify-section > .featured-product--has-sticky-cta .product-form--button-container');

  if (elements && elements.length) {
    //Add Body Class
    document.body.classList.add('featured-product--has-sticky-cta');

    elements.forEach((element) => {
      const observer = new IntersectionObserver(([e]) => {
          e.target.classList.toggle('is-pinned', e.intersectionRatio < 1);
        },
        {
          threshold: [1],
        }
      );

      observer.observe(element);
    });
  }
});